module.exports = __webpack_public_path__ + "img/Team-RobertBarrosa.92475201.png";